import {
  GET_PENDING_BUYERS_SUCCESS,
  GET_PENDING_BUYERS_FAILURE,
} from '../../../../config/constants/ActionTypes'

export default (state = {}, action) => {
  switch (action.type) {
    case GET_PENDING_BUYERS_SUCCESS: {
      return {
        ...state,
        pendingBuyers: action.payload.buyers,
      }
    }

    case GET_PENDING_BUYERS_FAILURE: {
      return {
        ...state,
        getPendingBuyersError: action.payload.error,
      }
    }

    default:
      return state
  }
}
